module.exports = __webpack_public_path__ + "img/logun.a26b057e.svg";